import React from 'react';
import { Chip } from '@mui/material';

// Membership flag shown next to a member's name.
// All tiers use the site theme green (#009640); the emoji + label still show the tier.
const TIERS = {
  silver: { label: 'Silver', icon: '\uD83E\uDD48' },
  gold: { label: 'Gold', icon: '\uD83E\uDD47' },
  platinum: { label: 'Platinum', icon: '\uD83D\uDC8E' },
};

const THEME_GREEN = '#009640';

export default function MembershipBadge({ tier, withLabel = true, sx }) {
  const meta = TIERS[String(tier || '').toLowerCase().trim()];
  if (!meta) return null;
  return (
    <Chip
      size="small"
      icon={<span style={{ fontSize: 10, lineHeight: 1 }}>{meta.icon}</span>}
      label={withLabel ? meta.label : undefined}
      title={`Membership: ${meta.label}`}
      sx={{
        height: 22,
        fontSize: 10,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: '#ffffff',
        bgcolor: THEME_GREEN,
        border: `1px solid ${THEME_GREEN}`,
        '& .MuiChip-icon': { ml: '7px', mr: withLabel ? '-2px' : 0, color: 'inherit' },
        '& .MuiChip-label': { px: '8px', pb: '1px' },
        ...sx,
      }}
    />
  );
}
